import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../components/SeoHead";
import { SUPPORTED_COUNTRIES } from "../seo/siteData";

export default function SupportedCountriesPage() {
    return (
        <>
            <SeoHead
                title="Tiply Supported Countries in the Euro Area"
                description="Tiply supports eligible businesses in all 21 EU euro-area countries for EUR digital tipping, subject to verification, payout compatibility and local law."
                canonicalPath="/supported-countries/"
                localizedAlternates={false}
                schemaType="WebPage"
            />
            <main className="min-h-screen bg-gray-50 text-gray-800">
                <div className="mx-auto max-w-5xl px-4 py-12 md:px-6 md:py-20">
                    <Link to="/" className="text-sm font-semibold text-emerald-600 hover:text-emerald-700">← Back to Tiply</Link>
                    <div className="mt-8 rounded-3xl border border-gray-100 bg-white p-6 shadow-sm md:p-10">
                        <p className="text-sm font-bold uppercase tracking-widest text-emerald-600">Euro-area availability</p>
                        <h1 className="mt-3 text-4xl font-extrabold tracking-tight md:text-5xl">Tiply is available across the EU euro area</h1>
                        <p className="mt-5 max-w-3xl text-lg leading-relaxed text-gray-600">
                            Tiply supports eligible restaurants, cafés, bars, hotels, salons, spas and other service businesses in all 21 EU countries that use the euro. Tips are accepted and paid out in EUR.
                        </p>

                        <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                            {SUPPORTED_COUNTRIES.map((country) => (
                                <div key={country} className="flex items-center gap-3 rounded-xl border border-gray-100 bg-gray-50 px-4 py-3">
                                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100 text-sm font-bold text-emerald-700">✓</span>
                                    <span className="font-semibold">{country}</span>
                                </div>
                            ))}
                        </div>

                        <section className="mt-10 rounded-2xl bg-emerald-50 p-6">
                            <h2 className="text-xl font-bold">What “supported” means</h2>
                            <p className="mt-3 leading-relaxed text-gray-700">
                                Availability is subject to successful business and identity verification, compatible EUR payout details, payment-provider and banking availability, and compliance with applicable local law. Tiply may request additional information or decline, restrict or suspend onboarding where required.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-bold">Taxes and local obligations</h2>
                            <p className="mt-3 leading-relaxed text-gray-600">
                                Tiply does not provide tax, payroll or legal advice. Businesses and tip recipients remain responsible for determining and meeting their local reporting, employment and tax obligations.
                            </p>
                        </section>

                        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
                            <a href="/#contact" className="rounded-lg bg-black px-6 py-3 text-center font-semibold text-white hover:bg-neutral-800">Ask about onboarding</a>
                            <Link to="/terms/" className="rounded-lg border border-gray-200 px-6 py-3 text-center font-semibold text-gray-700 hover:bg-gray-50">Read the Terms of Use</Link>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
